import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import {
  ATLButton,
  ATLSpacing,
  ATLTextBody,
  ATLTextHead,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

const Container = styled.SafeAreaView`
  margin-top: ${atlTheme.SpacingAtomic}px;
  flex: 1;
  background: #ffffff;
  width: 100%;
  padding-top: ${atlTheme.SpacingDistribute + atlTheme.SpacingBase}px;
`
const ButtonWrapper = styled.View`
  position: absolute;
  bottom: ${atlTheme.SpacingDistribute + atlTheme.SpacingMarginal}px;
  width: 100%;
`

export const VerificationScreen: NavigationStackScreenComponent = () => {
  return (
    <Container>
      <ATLSpacing type={SpacingSizesEnum.marginal} />
      <ATLSpacing type={SpacingSizesEnum.marginal} />
      <ATLTextHead textAlignment={TextAlignmentEnum.left}>
        {formatMessage(messages.signUpVerification_title)}
      </ATLTextHead>
      <ATLTextBody labelBaseProps={{ multilineLimit: 3 }}>
        {formatMessage(messages.signUpVerification_description_line1)}
      </ATLTextBody>
      <ATLTextBody labelBaseProps={{ multilineLimit: 3 }}>
        {formatMessage(messages.signUpVerification_description_line2)}
      </ATLTextBody>
      <ButtonWrapper>
        <ATLButton
          title={formatMessage(messages.signUpVerification_actionButtonTitle)}
          onPress={Coordinator.goToLogin}
          buttonBaseProps={{
            borderRadius: atlTheme.BorderRadius100,
          }}
        />
      </ButtonWrapper>
    </Container>
  )
}

VerificationScreen.navigationOptions = CustomHeader(formatMessage(messages.signUpVerification_appHeaderTitle), false)
